var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLogoBg = function SvgLogoBg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 1,
    x2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#13cae2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7328f0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "jl-logo-rect-simple",
    transform: "translate(-70 -435)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "rect",
    width: 400,
    height: 400,
    rx: 80,
    transform: "translate(70 435)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "jl-logo-simple",
    transform: "translate(-36 412.486)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "border",
    d: "M206,297.514v-25h37.5v-100H206v-25H406v25H368.5v100H406v25H331v-25h12.5v-100h-75v100H281v25Z",
    fill: "#fff"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogoBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-bg.2236e279.svg";
export { ForwardRef as ReactComponent };